import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { SidebarDataDocument } from './graphql/sidebarData.gql';

export const useSidebarData = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error('companyProfileId is undefined in useSidebarData');
  }
  const { data, error, loading } = useQuery(SidebarDataDocument, {
    variables: {
      companyProfileId: companyProfileId as string,
    },
  });

  if (loading || error || !data) {
    return { error, loading, remainingReferrerAmount: null };
  }

  return {
    error,
    loading,
    remainingReferrerAmount: data.viewer.companyUser.remainingReferrerAmount,
  };
};

export type RemainingReferrerAmount = NonNullable<
  NonNullable<
    Awaited<ReturnType<typeof useSidebarData>>['remainingReferrerAmount']
  >
>;
